import { useApiPost } from '@/api/main/query'
import { topupsAPI } from '@/entities/topups'
import { useToast } from '@/shared/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

export const useConfirmTopupDialog = ({
  queryKey,
  selectedTopupId,
}: {
  queryKey: unknown[]
  selectedTopupId: string
}) => {
  const [modalVisible, setModalVisible] = useState(false)

  const { addToast } = useToast()
  const queryClient = useQueryClient()

  const { mutate: confirmTopup } = useApiPost<
    {
      id: string
      description: string
    },
    { id: string }
  >(topupsAPI.item(selectedTopupId), {
    onSuccess: () => {
      addToast('Успех!', 'Платеж подтвержден', 'success')
      queryClient.invalidateQueries({ queryKey: queryKey })
    },
    onError: (error) => {
      addToast('Ошибка!', error.message, 'error')
    },
  })

  const openDialog = () => {
    setModalVisible(true)
  }

  const submitDialog = () => {
    if (selectedTopupId) {
      console.log({ selectedTopupId })
      confirmTopup({ id: selectedTopupId })
      setModalVisible(false)
    }
  }

  return {
    modalVisible,
    setModalVisible,
    openDialog,
    submitDialog,
  }
}
